import { List as MantineList, ListProps } from '@mantine/core';

export type IListProps = ListProps;

/** @registry Design-layer pass-through over Mantine List; import this instead of @mantine/core List outside src/design. Compound statics (List.Item) are preserved. */
export const List = MantineList;
